import type { Locale } from '../../../utils/intl/locale';

const deLocalization = {
  buttonLabel: 'Datum Auswählen',
  placeholder: '',
  selectedDateMessage: 'Ausgewähltes Datum ist',
  prevMonthLabel: 'Voriger Monat',
  nextMonthLabel: 'Nächster Monat',
  monthSelectLabel: 'Monat',
  yearSelectLabel: 'Jahr',
  closeLabel: 'Fenster schließen',
  calendarHeading: 'Wählen Sie ein Datum',
  dayNames: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],
  monthNames: [
    'Jänner',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  locale: 'de',
} as const;

export const datepickerLocalization = {
  de: deLocalization,
} satisfies Partial<Record<Locale, typeof deLocalization>>;

export type DuetLocalization = typeof deLocalization;
